function Loader({ message }) {
	return (
		<div className='fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50'>
			<div className="h-[100vh] w-full flex flex-col justify-center items-center">
				<div className="relative flex justify-center items-center w-[80px] h-[80px] overflow-hidden rounded-full animate-spin-slow bg-[conic-gradient(transparent,_#e20074)]">
					<div className="absolute top-0 w-[5px] h-[5px] bg-primary rounded-[50%]"></div>
					<div className="w-[50px] h-[50px] bg-[#f5f5f5] rounded-full"></div>
				</div>
				{message && <p className="text-center font-teleGroteskNextBold text-white">{message}</p>}
			</div>
		</div>
	)
}

export default Loader
